


import TiwiMixin from '../mixins/TiwiMixin'
import ModalPopup from './ModalPopup.vue';
export default {
  mixins: [TiwiMixin],

  components: {
    ModalPopup
  },
  props: {
    content: {
      required: true,
      type: Object,
    },
    isModal: {
      required: false,
      default: false,
      type: Boolean,
    },


  },
  data() {
    return {
      showModal: false,
      is_playing: false,
    }
  },
  mounted: function () {


  },
  computed: {

  },
  methods: {
    playVideo: function () {
      this.is_playing = true;
      this.$refs.videoRef.play();
    },
    pauseVideo: function () {
      if (this.is_playing) {
        this.is_playing = false;
        this.$refs.videoRef.pause();
      }
    },
    openModal: function () {
      this.showModal = true;
      this.playVideo();
    },
    closeModal: function () {
      this.showModal = false;
      this.pauseVideo();
    },
  },
  watch: {
  }
}
